module.exports = __webpack_public_path__ + "assets/media/bolts-flipped.4f3c1f97.svg";